<template>
  <div>
    <Slide right :isOpen="this.open">
      <ul class="flex flex-col items-start text-white uppercase">
        <li class="w-full py-4"><a href="/">home</a></li>
        <li class="w-full py-4"><a href="/events">eventi</a></li>
        <li class="w-full py-4"><a href="/categories">temi</a></li>
        <li class="w-full py-4"><a href="/speakers">speaker</a></li>
      </ul>
    </Slide>
  </div>
</template>

<script>
import { Slide } from "vue-burger-menu";
export default {
  data() {
    return {
      open: false
    };
  },
  methods: {
    openMenu() {
      this.open = true;
    }
  },
  components: {
    Slide
  }
};
</script>


<style>
.bm-burger-button {
    position: absolute;
    width: 36px;
    height: 30px;
    left:auto;
    right: 36px!important;
    top: 16px!important;
    cursor: pointer;
    right: 30px;
}

.bm-menu {
    background-color: rgba(219, 39, 119, 1);
}

</style>